import { Injectable } from "@angular/core";
import * as _ from "lodash";

import { DisplayService } from "../../../display/display.service";
import { ADPolicyState } from "src/app/constants/ad-policy.constants";
import { LoggerService } from "src/app/services/logger/logger.service";
import { DeviceSettingsFeatureToggle } from "src/app/enums/feature-toggle.enum";

@Injectable({
	providedIn: "root",
})
export class CameraDefaultValueService {
	constructor(
		private displayService: DisplayService,
		private logger: LoggerService
	) { }

	initialize(adTags: any): void {
		const cameraTag = _.get(adTags, DeviceSettingsFeatureToggle.DisplayAndCameraCamera);
		const isCameraAdPolicyEnabled = cameraTag === ADPolicyState.ENABLED;
		if (isCameraAdPolicyEnabled) {
			this.setDefaultValues();
		}
	}

	private async setDefaultValues() {
		try {
			if (this.displayService.isShellAvailable) {
				await this.displayService.initializeCameraAsync();
				this.displayService.resetCameraSettings();
				this.displayService.setCameraPrivacyModeState(false);
			}
		} catch (error) {
			this.logger.error('CameraDefaultValueService: ', error);
		}
	}
}
